export default {
    firstToCreate: 'Sé el primero en crear un hilo en este foro',
    firstToPostInCategory: 'Sé el primero en publicar en esta categoría',
    firstToRespondToTopic: '¡Sé el primero en responder a este tema!',
    createNewThread: 'Crear nuevo hilo',
    thread: 'hilo',
    viewThread: 'Ver hilo',
    replies: 'Respuestas',
    noReplies: 'Sin respuestas',
    reply: 'responder',
    _reply: 'Responder',
    ReplyTo: 'Responder a',
    replyToThisQuestion: 'Responder a esta pregunta',
    onceRepliedModeratorMayRespond: 'Una vez que hayas respondido, el moderador del foro puede responder a tu respuesta',
    onceRepliedCanViewResponses: 'Una vez que hayas respondido, podrás ver las respuestas de otros participantes',
    loadingResponses: 'Cargando respuestas',
    hideXReplies: 'Ocultar {count} respuestas',
    showXReplies: 'Mostrar {count} respuestas',
    hideMostRecentReplies: 'Ocultar respuestas más recientes',
    showMostRecentReplies: 'Mostrar respuestas más recientes',
    post: 'Publicar',
    message: 'Mensaje',
    typeMessage: 'Escribe un mensaje',
    addPost: 'Añadir publicación',
    addMessage: 'Añadir mensaje',
    editPost: 'Editar publicación',
    editPostWithMedia: 'Editar publicación con multimedia',
    createPostWithMedia: 'Crear publicación con multimedia',
    deleteMessage: 'Eliminar mensaje',
    deleteMessageConfirm: '¿Estás seguro de que quieres eliminar este mensaje?',
    pinPost: 'Fijar publicación',
    media: 'Multimedia',
    uploadMedia: 'Subir multimedia',
    categories: 'categorías',
    goBack: 'Volver',
    goBackPrevious: 'Volver a la página anterior',
    goBackToCategory: 'Volver a la categoría {name}',
    loadingLatestThreads: 'Cargando los últimos hilos',
    loadingDiscussionForum: 'Cargando el foro de discusión',
    dontShowAgainForTask: 'No mostrar de nuevo para esta tarea',
    title: 'Título',
    beTheFirst: 'Sé el primero en responder a este hilo'
};
